<div class="confirm-dialog" [class.confirm-dialog--danger]="danger">

  <header class="confirm-dialog__header">
    <div class="confirm-dialog__title">
      <mat-icon>{{icon}}</mat-icon>
      <span>{{description}}</span>
    </div>
    <button class="confirm-dialog__close" type="button" (click)="close()" aria-label="Close" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <p class="confirm-dialog__message" *ngIf="message">{{message}}</p>

  <footer class="confirm-dialog__footer">
    <button class="confirm-dialog__btn confirm-dialog__btn--ghost" type="button" (click)="close()">
      {{ cancelText }}
    </button>
    <button class="confirm-dialog__btn"
            [class.confirm-dialog__btn--primary]="!danger"
            [class.confirm-dialog__btn--danger]="danger"
            type="button"
            (click)="confirm()">
      {{ confirmText }}
    </button>
  </footer>
</div>
